import Dbm from "dbm";
import Website from "../../index.js";

//import * as PIXI from "pixi.js";
//import Matter from "matter-js";

export default class GamePlay extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        this.item.requireProperty("game", null);
        this.item.requireProperty("physicsEngine", null);

        this.item.requireProperty("chanceOfDouble", 0);
        this.item.requireProperty("chanceOfTripple", 0);

        this.item.requireProperty("bossLifes", 3);

        this.item.requireProperty("stepsForHeart", 5);
        this.item.requireProperty("stepsSinceLastHeart", 0);
        this.item.requireProperty("gameMode", "normal");
        this.item.requireProperty("bossState", "intro").addUpdate(this._getScopedCallFunctionCommand(this._bossStateChanged));

        let pixiLayer = new PIXI.Container();
        this.item.requireProperty("pixiLayer", pixiLayer);

        {
            let layer = new PIXI.Container()
            pixiLayer.addChild(layer);
            this.item.requireProperty("backgroundLayer", layer);
        }

        {
            let parallaxLayer = new PIXI.Container()
            pixiLayer.addChild(parallaxLayer);
            this.item.requireProperty("parallaxLayer", parallaxLayer);

            {
                let layer = new PIXI.Container()
                parallaxLayer.addChild(layer);
                this.item.requireProperty("parallaxLayer4", layer);
            }

            {
                let layer = new PIXI.Container()
                parallaxLayer.addChild(layer);
                this.item.requireProperty("parallaxLayer3", layer);
            }

            {
                let layer = new PIXI.Container()
                parallaxLayer.addChild(layer);
                this.item.requireProperty("parallaxLayer2", layer);
            }

            {
                let layer = new PIXI.Container()
                parallaxLayer.addChild(layer);
                this.item.requireProperty("parallaxLayer1", layer);
            }
        }

        {
            let layer = new PIXI.Container()
            pixiLayer.addChild(layer);
            this.item.requireProperty("groundLayer", layer);
        }

        {
            let layer = new PIXI.Container()
            pixiLayer.addChild(layer);
            this.item.requireProperty("groundBackLayer", layer);
        }

        {
            let layer = new PIXI.Container()
            pixiLayer.addChild(layer);
            this.item.requireProperty("gameLayer", layer);
        }

        {
            let layer = new PIXI.Container()
            pixiLayer.addChild(layer);
            this.item.requireProperty("groundFrontLayer", layer);
        }

        {
            let layer = new PIXI.Container()
            pixiLayer.addChild(layer); //MEDEBUG: //
            this.item.requireProperty("hudLayer", layer);
        }

        {
            let fadeLayer = new Website.game.graphics.HoleFade();
            pixiLayer.addChild(fadeLayer.item.pixiLayer);
            this.item.requireProperty("fadeLayer", fadeLayer.item);
        }

        {
            let layer = new PIXI.Container()
            pixiLayer.addChild(layer); //MEDEBUG: //
            this.item.requireProperty("scoreLayer", layer);
        }

        this.item.requireProperty("position", 0);
        this.item.requireProperty("cameraPosition", 0);

        this.item.requireProperty("nextEmemySpawnPosition", 0);
        this.item.requireProperty("cooldownLength", 0);
        this.item.requireProperty("levelLength", 0);

        this.item.requireProperty("nextFlyingEmemySpawnPosition", 0);
        this.item.requireProperty("minFlyingEnemyLength", 0.25*Website.game.Sizes.WIDTH);
        this.item.requireProperty("maxFlyingEnemyLength", 1.25*Website.game.Sizes.WIDTH);

        this.item.requireProperty("nextCoinSpawnPosition", 0);
        this.item.requireProperty("coinCooldownLength", 0);

        this.item.requireProperty("lives", 3);
        this.item.requireProperty("walkSpeed", Website.game.Sizes.START_WALK_SPEED);

        this.item.physicsEngine = Matter.Engine.create();
        this.item.physicsEngine.gravity.y = 1.4;

        this.enemies = [];
        this.coins = [];
        this.projectiles = [];
        this.graphics = [];

        this.width = 320;
        this.height = 180;

        this.nextCoinSpawnTime = 0;

        this.groundPosition = 140;
        this.playerPosition = 10;
        this.characterWidth = 40;
        this.characterHeight = 60;

        let floorBody = Matter.Bodies.rectangle(0, 20, 2000, 40, {
            isStatic: true,
            label: "ground",
            collisionFilter: Website.game.PhysicsGroups.createCollisionFilter(Website.game.PhysicsGroups.GROUND, Website.game.PhysicsGroups.GROUND_INTERACTIONS)
        });

        Matter.World.add(this.item.physicsEngine.world, floorBody);

        let player = new Website.game.gameplay.player.Player();
        player.item.setValue("gamePlay", this.item);
        this.item.setValue("player", player.item);

        this.playerBody = player.item.physicsBody;


        Matter.World.add(this.item.physicsEngine.world, player.item.physicsBody);
        Matter.Events.on(this.item.physicsEngine, "collisionStart", this._callback_collisionStart.bind(this));
        Matter.Events.on(this.item.physicsEngine, "collisionEnd", this._callback_collisionEnd.bind(this));

        this.nextCoinSpawnInterval = 0.5;
        this.nextEnemySpawnInterval = 2;

        let keyboardController = new Website.game.gameplay.player.KeyboardController();
        this.item.setValue("keyboardController", keyboardController.item);
        keyboardController.item.setValue("gamePlay", this.item);
        keyboardController.item.setValue("player", player.item);

        let touchController = new Website.game.gameplay.player.TouchController();
        this.item.setValue("touchController", touchController.item);
        touchController.item.setValue("gamePlay", this.item);
        touchController.item.setValue("player", player.item);

        let boss = new Website.game.gameplay.gameobjects.Boss();
        boss.item.setValue("gamePlay", this.item);
        this.item.setValue("boss", boss.item);
    }

    createEnemy(aX) {

        let sprite = null;
        let playerId = this.item.game.playerId;
        if(playerId === "affe") {
            let mainTexture = Website.game.getTextures("enemies/stone", "stone")[0];
            let animationTextures = Website.game.getTextures("enemies/stone", "animation");

            let animation = [
                mainTexture,
                mainTexture,
                mainTexture,
                mainTexture,
                mainTexture,
                mainTexture,
                mainTexture,
                mainTexture,
                mainTexture,
                mainTexture,
                mainTexture,
                mainTexture,
                mainTexture,
                mainTexture,
                mainTexture,
                mainTexture,
                animationTextures[1],
                animationTextures[1],
                mainTexture,
                animationTextures[1],
                animationTextures[1],
                mainTexture,
                mainTexture,
                mainTexture,
                mainTexture,
                mainTexture,
                mainTexture,
                mainTexture,
                mainTexture,
                mainTexture,
                mainTexture,
                mainTexture,
                mainTexture,
                mainTexture,
                animationTextures[1],
                animationTextures[1],
                mainTexture
            ];

            sprite = new PIXI.AnimatedSprite(animation);
            
            sprite.anchor.set(0.5, 1);
            sprite.animationSpeed = 0.2;
            sprite.gotoAndPlay(Math.floor(Math.random()*animation.length));
        }
        else if(playerId === "saga") {
            sprite = Website.game.getSprite("enemies/red-tape", "red-tape");

        }
        else if(playerId === "theo") {
            sprite = Website.game.getSprite("enemies/computer", "computer");
        }
        else if(playerId === "svenne") {
            let order = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,2,3,0];
            sprite = Website.game.getAnimatedSpriteWithOrder("enemies/log", "animation", order);
            sprite.anchor.set(0.5, 1);
            sprite.animationSpeed = 0.5;
            sprite.gotoAndPlay(Math.floor(Math.random()*order.length));
        }
        else if(playerId === "ninni") {
            sprite = Website.game.getAnimatedSprite("enemies/milk", "animation");
            sprite.animationSpeed = 0.2;
            sprite.gotoAndPlay(Math.floor(Math.random()*10));
        }
        else {
            sprite = Website.game.getSprite("enemies/computer", "computer");
        }

        let enemy = new Website.game.gameplay.gameobjects.GroundEnemy();
        enemy.item.enemyType = "ground";
        enemy.item.x = aX;
        enemy.setSprite(sprite);
        enemy.setIntialPosition(this.item.cameraPosition);
        Matter.World.add(this.item.physicsEngine.world, enemy.item.physicsBody);
        this.item.gameLayer.addChild(enemy.item.pixiLayer);

        this.enemies.push(enemy.item); 
    }

    createFlyingEnemy(aX, aY) {
        //console.log("createFlyingEnemy");

        //return; //MEDEBUG

        let mainTexture = Website.game.getTextures("enemies/airplane", "airplane")[0];
        let animationTextures = Website.game.getTextures("enemies/stone", "animation");

        let animation = [
            mainTexture,
        ];

        let sprite = new PIXI.AnimatedSprite(animation);
        
        sprite.anchor.set(0.5, 1);
        sprite.animationSpeed = 0.2;
        sprite.gotoAndPlay(Math.floor(Math.random()*animation.length));
        

        let enemy = new Website.game.gameplay.gameobjects.FlyingEnemy();
        enemy.item.enemyType = "flying";
        enemy.item.x = aX;
        enemy.item.y = aY;
        enemy.item.speed = 60;
        enemy.setSprite(sprite);
        enemy.setIntialPosition(this.item.cameraPosition);
        Matter.World.add(this.item.physicsEngine.world, enemy.item.physicsBody);
        this.item.gameLayer.addChild(enemy.item.pixiLayer);

        this.enemies.push(enemy.item); 
    }

    createBossFlyingEnemy() {
        //console.log("createBossFlyingEnemy");

        if(this.item.gameMode !== "boss") {
            return;
        }

        let mainTexture = Website.game.getTextures("enemies/airplane", "airplane")[0];
        let animationTextures = Website.game.getTextures("enemies/stone", "animation");

        let animation = [
            mainTexture,
        ];

        let sprite = new PIXI.AnimatedSprite(animation);
        
        sprite.anchor.set(0.5, 1);
        sprite.animationSpeed = 0.2;
        sprite.gotoAndPlay(Math.floor(Math.random()*animation.length));
        

        let enemy = new Website.game.gameplay.gameobjects.FlyingEnemy();
        enemy.item.enemyType = "flying";
        enemy.item.x = this.item.cameraPosition-Website.game.Sizes.CENTER_X+0.9*Website.game.Sizes.WIDTH-10;
        enemy.item.y = Website.game.Sizes.CHARACTER_HEIGHT+20;
        enemy.item.speed = 100;
        enemy.item.speedY = 30+40*(2*Math.random()-1);
        enemy.setSprite(sprite);
        enemy.setIntialPosition(this.item.cameraPosition);
        Matter.World.add(this.item.physicsEngine.world, enemy.item.physicsBody);
        this.item.gameLayer.addChild(enemy.item.pixiLayer);

        this.enemies.push(enemy.item); 
    }

    getEnemyFromPhysicsBody(aPhysicsBody) {
        return Dbm.utils.ArrayFunctions.getItemByIfExists(this.enemies, "physicsBody", aPhysicsBody);
    }

    removeEnemy(aPhysicsBody) {

        let index = Dbm.utils.ArrayFunctions.getItemIndexByIfExists(this.enemies, "physicsBody", aPhysicsBody);
        if (index === -1) return;
        let enemy = this.enemies[index];

        Matter.World.remove(this.item.physicsEngine.world, aPhysicsBody);
        this.item.gameLayer.removeChild(enemy.pixiLayer);

        this.enemies.splice(index, 1);
    }

    _callback_collisionStart(aEvent) {
        for (const pair of aEvent.pairs) {
            //console.log(pair.bodyA.label, pair.bodyB.label);
            if (
            (pair.bodyA.label === "player" && pair.bodyB.label === "ground") ||
            (pair.bodyB.label === "player" && pair.bodyA.label === "ground")
            ) {
                this.item.player.isGrounded = true;
                this.item.player.controller.jumpEnded();
            }

            const isProjectileGround =
            (pair.bodyA.label === "projectile" && pair.bodyB.label === "ground") ||
            (pair.bodyB.label === "projectile" && pair.bodyA.label === "ground");

            if (isProjectileGround) {
            const projectileBody =
                pair.bodyA.label === "projectile" ? pair.bodyA : pair.bodyB;

                this.removeProjectile(projectileBody);
            }

            const isPlayerCoin =
            (pair.bodyA.label === "player" && pair.bodyB.label === "coin") ||
            (pair.bodyB.label === "player" && pair.bodyA.label === "coin");

            if (isPlayerCoin) {
                const coinBody = pair.bodyA.label === "coin" ? pair.bodyA : pair.bodyB;
                this.collectCoin(coinBody);

                let newSpeed = this.item.walkSpeed + 1; 
                this.item.walkSpeed = Math.min(newSpeed, Website.game.Sizes.MAX_WALK_SPEED); 
            }

            const isPlayerHeart =
            (pair.bodyA.label === "player" && pair.bodyB.label === "heart") ||
            (pair.bodyB.label === "player" && pair.bodyA.label === "coin");

            if (isPlayerHeart) {
                const coinBody = pair.bodyA.label === "heart" ? pair.bodyA : pair.bodyB;
                this.gainLife();
                this.removeCoin(coinBody);
            }

            const isProjectileEnemy =
            (pair.bodyA.label === "projectile" && pair.bodyB.label === "enemy") ||
            (pair.bodyB.label === "projectile" && pair.bodyA.label === "enemy");

            if (isProjectileEnemy) {
                const projectileBody = pair.bodyA.label === "projectile" ? pair.bodyA : pair.bodyB;
                const enemyBody = pair.bodyA.label === "enemy" ? pair.bodyA : pair.bodyB;

                let enemyItem = this.getEnemyFromPhysicsBody(enemyBody);

                if(!enemyItem) {
                    //MENOTE: could happen if it has collided multiple times
                }
                else if(enemyItem.enemyType === "flying") {
                    let paperGraphics = new Website.game.gameplay.graphics.PhysicsGraphics();
                    let sprite = Website.game.getSprite("objects/paper-ball", "main");
                    sprite.anchor.set(0.5, 0.5);
                    paperGraphics.item.x = enemyItem.x;
                    paperGraphics.item.y = enemyItem.y;
                    paperGraphics.setIntialPosition(this.item.cameraPosition);
                    Matter.World.add(this.item.physicsEngine.world, paperGraphics.item.physicsBody);

                    paperGraphics.item.physicsBody.torque = 0.5;
                    let forceScale = 0.003;
                    paperGraphics.applyForce(forceScale*(2*Math.random()-1), 1*Math.random()*forceScale);
                    this.addGraphics(paperGraphics.item, this.item.gameLayer);
                    paperGraphics.addSprite(sprite);
                }
                else {
                    let playerId = this.item.game.playerId;
                    if(playerId === "affe") {
                        let numberOfStones = 4+Math.round(Math.random()*4)
                        for(let i = 0; i < numberOfStones; i++) {
                            let partGraphics = new Website.game.gameplay.graphics.PhysicsGraphics();
                            let sprite = Website.game.getSprite("enemies/stone", "part");
                            sprite.anchor.set(0.5, 0.5);
                            partGraphics.item.x = enemyItem.x;
                            partGraphics.item.y = enemyItem.y;
                            partGraphics.setIntialPosition(this.item.cameraPosition);
                            Matter.World.add(this.item.physicsEngine.world, partGraphics.item.physicsBody);

                            partGraphics.item.physicsBody.torque = 0.5;
                            let forceScale = 0.01;
                            partGraphics.applyForce(forceScale*(2*Math.random()-1), 1*(Math.random()+1)*forceScale);
                            this.addGraphics(partGraphics.item, this.item.gameLayer);
                            partGraphics.addSprite(sprite);
                        }
                    }
                    else if(playerId === "saga") {

                        {
                            let partGraphics = new Website.game.gameplay.graphics.PhysicsGraphics();
                            let sprite = Website.game.getSprite("enemies/red-tape", "eye");
                            sprite.anchor.set(0.5, 0.5);
                            partGraphics.item.x = enemyItem.x-6;
                            partGraphics.item.y = enemyItem.y+20;
                            partGraphics.setIntialPosition(this.item.cameraPosition);
                            Matter.World.add(this.item.physicsEngine.world, partGraphics.item.physicsBody);

                            partGraphics.item.physicsBody.torque = 0.5*(2*Math.random()-1);
                            let forceScale = 0.01;
                            partGraphics.applyForce(forceScale*-1*(0.1+Math.random()), 1*(0.5+Math.random())*forceScale);
                            this.addGraphics(partGraphics.item, this.item.gameLayer);
                            partGraphics.addSprite(sprite);
                        }

                        {
                            let partGraphics = new Website.game.gameplay.graphics.PhysicsGraphics();
                            let sprite = Website.game.getSprite("enemies/red-tape", "eye");
                            sprite.anchor.set(0.5, 0.5);
                            partGraphics.item.x = enemyItem.x+6;
                            partGraphics.item.y = enemyItem.y+20;
                            partGraphics.setIntialPosition(this.item.cameraPosition);
                            Matter.World.add(this.item.physicsEngine.world, partGraphics.item.physicsBody);

                            partGraphics.item.physicsBody.torque = 0.5*(2*Math.random()-1);
                            let forceScale = 0.01;
                            partGraphics.applyForce(forceScale*1*(0.1+Math.random()), 1*(0.5+Math.random())*forceScale);
                            this.addGraphics(partGraphics.item, this.item.gameLayer);
                            partGraphics.addSprite(sprite);
                        }

                        let numberOfStones = 8+Math.round(Math.random()*4)
                        for(let i = 0; i < numberOfStones; i++) {
                            let partGraphics = new Website.game.gameplay.graphics.PhysicsGraphics();
                            let sprite = Website.game.getSprite("enemies/red-tape", "part");
                            sprite.anchor.set(0.5, 0.5);
                            partGraphics.item.x = enemyItem.x+11*(2*Math.random()-1);
                            partGraphics.item.y = enemyItem.y-20*(Math.random());
                            partGraphics.setIntialPosition(this.item.cameraPosition);
                            Matter.World.add(this.item.physicsEngine.world, partGraphics.item.physicsBody);

                            partGraphics.item.physicsBody.torque = 0.1*(2*Math.random()-1);
                            partGraphics.item.physicsBody.frictionAir = 0.1;
                            let forceScale = 0.02;
                            partGraphics.applyForce(forceScale*(2*Math.random()-1), 1*(Math.random()+1)*forceScale);
                            this.addGraphics(partGraphics.item, this.item.gameLayer);
                            partGraphics.addSprite(sprite);
                        }
                    }
                    else if(playerId === "theo") {

                        let numberOfStones = 3+Math.round(Math.random()*2);
                        for(let i = 0; i < numberOfStones; i++) {
                            let partGraphics = new Website.game.gameplay.graphics.PhysicsGraphics();
                            let sprite = Website.game.getSprite("enemies/computer", "spinning-ball");
                            sprite.anchor.set(0.5, 0.5);
                            partGraphics.item.x = enemyItem.x+11*(2*Math.random()-1);
                            partGraphics.item.y = enemyItem.y-20*(Math.random());
                            partGraphics.setIntialPosition(this.item.cameraPosition);
                            Matter.World.add(this.item.physicsEngine.world, partGraphics.item.physicsBody);

                            partGraphics.item.physicsBody.torque = 0.3;
                            partGraphics.item.physicsBody.rotation = Math.random()*2*Math.PI;
                            let forceScale = 0.02;
                            partGraphics.applyForce(forceScale*0.5*(2*Math.random()-1), 0.3*(Math.random()+1)*forceScale);
                            this.addGraphics(partGraphics.item, this.item.gameLayer);
                            partGraphics.addSprite(sprite);
                        }

                        {
                            let partGraphics = new Website.game.gameplay.graphics.PhysicsGraphics();
                            let sprite = Website.game.getSprite("enemies/computer", "part");
                            sprite.anchor.set(0.5, 0.5);
                            partGraphics.item.x = enemyItem.x-3;
                            partGraphics.item.y = enemyItem.y+7;
                            partGraphics.setIntialPosition(this.item.cameraPosition);
                            Matter.World.add(this.item.physicsEngine.world, partGraphics.item.physicsBody);

                            let forceScale = 0.01;
                            partGraphics.applyForce(-0.3*forceScale, 0*(0.1+Math.random())*forceScale);
                            this.addGraphics(partGraphics.item, this.item.gameLayer);
                            partGraphics.addSprite(sprite);
                        }

                        
                    }
                    else if(playerId === "svenne") {
                        let numberOfStones = 2+Math.round(Math.random()*1);
                        for(let i = 0; i < numberOfStones; i++) {
                            let partGraphics = new Website.game.gameplay.graphics.PhysicsGraphics();
                            let sprite = Website.game.getSprite("enemies/log", "part");
                            sprite.anchor.set(0.5, 0.5);
                            partGraphics.item.x = enemyItem.x+11*(2*Math.random()-1);
                            partGraphics.item.y = enemyItem.y-20*(Math.random());
                            partGraphics.setIntialPosition(this.item.cameraPosition);
                            Matter.World.add(this.item.physicsEngine.world, partGraphics.item.physicsBody);

                            partGraphics.item.physicsBody.torque = 0.1*(2*Math.random()-1);
                            let forceScale = 0.02;
                            partGraphics.applyForce(forceScale*0.5*(2*Math.random()-1), 0.3*(Math.random()+1)*forceScale);
                            this.addGraphics(partGraphics.item, this.item.gameLayer);
                            partGraphics.addSprite(sprite);
                        }
                    }
                    else {
                        {
                            let partGraphics = new Website.game.gameplay.graphics.PhysicsGraphics();
                            let sprite = Website.game.getSprite("enemies/milk", "part-left");
                            sprite.anchor.set(0.5, 0.5);
                            partGraphics.item.x = enemyItem.x-6;
                            partGraphics.item.y = enemyItem.y+20;
                            partGraphics.setIntialPosition(this.item.cameraPosition);
                            Matter.World.add(this.item.physicsEngine.world, partGraphics.item.physicsBody);

                            partGraphics.item.physicsBody.torque = 0.5*(2*Math.random()-1);
                            let forceScale = 0.01;
                            partGraphics.applyForce(forceScale*-1*(0.1+Math.random()), 1*(0.5+Math.random())*forceScale);
                            this.addGraphics(partGraphics.item, this.item.gameLayer);
                            partGraphics.addSprite(sprite);
                        }

                        {
                            let partGraphics = new Website.game.gameplay.graphics.PhysicsGraphics();
                            let sprite = Website.game.getSprite("enemies/milk", "part-right");
                            sprite.anchor.set(0.5, 0.5);
                            partGraphics.item.x = enemyItem.x+6;
                            partGraphics.item.y = enemyItem.y+20;
                            partGraphics.setIntialPosition(this.item.cameraPosition);
                            Matter.World.add(this.item.physicsEngine.world, partGraphics.item.physicsBody);

                            partGraphics.item.physicsBody.torque = 0.5*(2*Math.random()-1);
                            let forceScale = 0.01;
                            partGraphics.applyForce(forceScale*1*(0.1+Math.random()), 1*(0.5+Math.random())*forceScale);
                            this.addGraphics(partGraphics.item, this.item.gameLayer);
                            partGraphics.addSprite(sprite);
                        }
                    }
                    
                }
                

                this.removeProjectile(projectileBody, true);
                this.removeEnemy(enemyBody);
                this.addScore(41);
                let sound = Website.game.getTextures("sounds/game", "explosion")[0];
                sound.play({loop: false, volume: 0.5});
                
            }

            const isProjectileBoss =
            (pair.bodyA.label === "projectile" && pair.bodyB.label === "boss") ||
            (pair.bodyB.label === "projectile" && pair.bodyA.label === "boss");

            if (isProjectileBoss) {
                const projectileBody = pair.bodyA.label === "projectile" ? pair.bodyA : pair.bodyB;
                const bossBody = pair.bodyA.label === "boss" ? pair.bodyA : pair.bodyB;

                this.removeProjectile(projectileBody, true);
                this.addScore(1000);
                let sound = Website.game.getTextures("sounds/game", "explosion")[0];
                sound.play({loop: false, volume: 0.5});

                this.injureBoss();
            }

            const isPlayerEnemy =
            (pair.bodyA.label === "player-damage" && pair.bodyB.label === "enemy") ||
            (pair.bodyB.label === "player-damage" && pair.bodyA.label === "enemy");

            if (isPlayerEnemy) {
                const playerBody = pair.bodyA.label === "player" ? pair.bodyA : pair.bodyB;
                const enemyBody = pair.bodyA.label === "enemy" ? pair.bodyA : pair.bodyB;
                this.removeEnemy(enemyBody);

                if(!this.item.player.invincible) {
                    this.item.position = this.item.cameraPosition-0.5*Website.game.Sizes.WIDTH;
                    this.item.player.isGrounded = true;
                    this.item.walkSpeed = Math.max(Website.game.Sizes.START_WALK_SPEED, this.item.walkSpeed-8);

                    this.loseLife();
                }
                
            }
        }
    }

    _callback_collisionEnd(aEvent)  {
        //console.log("collisionEnd");
        for (const pair of aEvent.pairs) {
            //console.log(">>>>", pair.bodyA.label, pair.bodyB.label);
            if (
            (pair.bodyA.label === "player" && pair.bodyB.label === "ground") ||
            (pair.bodyB.label === "player" && pair.bodyA.label === "ground")
            ) {
                this.item.player.isGrounded = false;
            }

            
        }
    }

    injureBoss() {

        this.item.bossLifes = Math.max(this.item.bossLifes-1, 0);
        if(this.item.bossLifes === 0) {
            this.item.levelLength = this.item.cameraPosition+Website.game.Sizes.WIDTH;

            //METODO: remove offscreen items

            this.item.gameLayer.removeChild(this.item.boss.pixiLayer);
            Matter.World.remove(this.item.physicsEngine.world, this.item.boss.physicsBody);

            this.item.boss.controller.stopFight();

            {
                let partGraphics = new Website.game.gameplay.graphics.PhysicsGraphics();
                let sprite = Website.game.getSprite("enemies/boss", "layer", 1);
                sprite.anchor.set(0.5, 0.5);
                partGraphics.item.x = this.item.cameraPosition;
                partGraphics.item.y = 80;
                partGraphics.setIntialPosition(this.item.cameraPosition);
                Matter.World.add(this.item.physicsEngine.world, partGraphics.item.physicsBody);

                partGraphics.item.physicsBody.torque = 0.1*(Math.random()-1);
                let forceScale = 0.02;
                partGraphics.applyForce(forceScale*0.5*(Math.random()-1), 0.3*(Math.random()+1)*forceScale);
                this.addGraphics(partGraphics.item, this.item.gameLayer);
                partGraphics.addSprite(sprite);
            }

            {
                let partGraphics = new Website.game.gameplay.graphics.PhysicsGraphics();
                let sprite = Website.game.getSprite("enemies/boss", "no-chair");
                sprite.anchor.set(0.5, 0.5);
                partGraphics.item.x = this.item.cameraPosition;
                partGraphics.item.y = 90;
                partGraphics.setIntialPosition(this.item.cameraPosition);
                Matter.World.add(this.item.physicsEngine.world, partGraphics.item.physicsBody);

                partGraphics.item.physicsBody.torque = 0.05*(Math.random());
                let forceScale = 0.02;
                partGraphics.applyForce(forceScale*0.5*(Math.random()), 0.5*(Math.random()+1)*forceScale);
                this.addGraphics(partGraphics.item, this.item.gameLayer);
                partGraphics.addSprite(sprite);
            }

            for(let i = 0; i < 3; i++) {
                let partGraphics = new Website.game.gameplay.graphics.PhysicsGraphics();
                let sprite = Website.game.getSprite("enemies/boss", "wheel");
                sprite.anchor.set(0.5, 0.5);
                partGraphics.item.x = this.item.cameraPosition+(10*(i-1));
                partGraphics.item.y = 10;
                partGraphics.setIntialPosition(this.item.cameraPosition);
                Matter.World.add(this.item.physicsEngine.world, partGraphics.item.physicsBody);

                partGraphics.item.physicsBody.torque = 0.1*(2*Math.random()-1);
                let forceScale = 0.02;
                partGraphics.applyForce(forceScale*0.5*(2*Math.random()-1), 0.6*(Math.random()+1)*forceScale);
                this.addGraphics(partGraphics.item, this.item.gameLayer);
                partGraphics.addSprite(sprite);
            }
        }
        else {
            this.item.boss.controller.hit();
        }

        
    }

    createProjectile(aX, aY) {
        let PROJECTILE_RADIUS = 5;

        const body = Matter.Bodies.circle(
            aX,
            aY,
            PROJECTILE_RADIUS,
            {
            restitution: 0.4,
            friction: 0.1,
            frictionAir: 0.01,
            label: "projectile",
            collisionFilter: Website.game.PhysicsGroups.createCollisionFilter(Website.game.PhysicsGroups.PROJECTILES, Website.game.PhysicsGroups.PROJECTILES_INTERACTIONS)
            }
        );
        

        Matter.World.add(this.item.physicsEngine.world, body);

        let sprite = null;
        let playerId = this.item.game.playerId;
        if(playerId === "affe"){
            sprite = new PIXI.Sprite(Website.game.getTextures("objects/dynamite", "main")[0]);
            sprite.anchor.set(0.5, 0.5);
        }
        else if(playerId === "svenne") {
            sprite = Website.game.getAnimatedSprite("objects/ball-bearings", "animation", 0.5);
            sprite.anchor.set(0.5, 0.5);
        }
        else if(playerId === "saga") {
            sprite = new PIXI.Sprite(Website.game.getTextures("objects/phone", "main")[0]);
            sprite.anchor.set(0.5, 0.5);
        }
        else if(playerId === "ninni") {
            sprite = new PIXI.Sprite(Website.game.getTextures("objects/milk-bottle", "main")[0]);
            sprite.anchor.set(0.5, 0.5);
        }
        else {
            sprite = new PIXI.Sprite(Website.game.getTextures("objects/cd", "main")[0]);
            sprite.anchor.set(0.5, 0.5);
        }
        

        this.item.gameLayer.addChild(sprite);

        let projectile = { body, sprite };
        this.projectiles.push(projectile);
        
        return projectile;
    }

    removeProjectile(body, isHit = false) {
        const index = this.projectiles.findIndex(p => p.body === body);
        if (index === -1) return;

        const { sprite } = this.projectiles[index];

        let effectsGraphics = new Website.game.gameplay.graphics.MovingGraphic();

        


        let playerId = this.item.game.playerId;
        if(playerId === "affe"){
            effectsGraphics.item.x = body.position.x+this.item.cameraPosition-Website.game.Sizes.CENTER_X;
            effectsGraphics.item.y = Website.game.Sizes.GROUND_POSITION+Website.game.Sizes.PLAYER_POSITION+body.position.y;
            effectsGraphics.item.speed = 1;

            this.item.gameLayer.addChild(effectsGraphics.item.pixiLayer);

            this.graphics.push(effectsGraphics.item);

            let blinkSprite = Website.game.getAnimatedSprite("effects/explosion", "animation", 0.5);
            blinkSprite.anchor.set(0.5, 0.5);
            blinkSprite.loop = false;
            blinkSprite.play();
            effectsGraphics.item.pixiLayer.addChild(blinkSprite);
        }
        else if(playerId === "saga"){
            effectsGraphics.item.x = body.position.x+this.item.cameraPosition-Website.game.Sizes.CENTER_X;
            effectsGraphics.item.y = Website.game.Sizes.GROUND_POSITION+Website.game.Sizes.PLAYER_POSITION+body.position.y;
            effectsGraphics.item.speed = 1;

            this.item.gameLayer.addChild(effectsGraphics.item.pixiLayer);

            this.graphics.push(effectsGraphics.item);

            if(isHit) {
                let numberOfStones = 2;
                for(let i = 0; i < numberOfStones; i++) {
                    let startX = 20*(2*Math.random()-1);
                    let startY = 20*(2*Math.random()-1);
                    let riseSprite = Website.game.getSprite("effects/ecommerce", "rise", Math.floor(4*Math.random()));
                    riseSprite.anchor.set(0.5, 0.5);
                    riseSprite.position.set(startX, startY);
                    effectsGraphics.item.pixiLayer.addChild(riseSprite);
                    let animation = Dbm.flow.externalObject(riseSprite);
                    animation.addProperty("alpha", 1);
                    animation.addProperty("y", startY, "position.y");

                    let moveLength = 20+10*Math.random();
                    let moveTime = 0.5+0.5*Math.random();
                    animation.item.properties.alpha.animateValue(0, 0.3, moveTime-0.3);
                    animation.item.properties.y.animateValue(startY-moveLength, moveTime);
                }

                {
                    let numberOfStones = 3;
                    for(let i = 0; i < numberOfStones; i++) {
                        let startX = Math.min(i, 1)*20*(2*Math.random()-1);
                        let startY = Math.min(i, 1)*20*(2*Math.random()-1);

                        let delay = (new Array(i*3)).fill(0);
                        let riseSprite = Website.game.getAnimatedSpriteWithOrder("effects/ecommerce", "up-arrow", delay.concat([0, 1, 2, 3, 4, 5, 6, 7, 0, 1, 2, 3, 4, 0, 4, 0, 4, 0]), 0.3);
                        riseSprite.loop = false;
                        riseSprite.play();
                        riseSprite.anchor.set(0.5, 0.5);
                        riseSprite.position.set(startX, startY);
                        effectsGraphics.item.pixiLayer.addChild(riseSprite);
                        
                    }
                }
            }
            else {
                let numberOfStones = 3;
                for(let i = 0; i < numberOfStones; i++) {
                    let startX = Math.min(i, 1)*20*(2*Math.random()-1);
                    let startY = Math.min(i, 1)*20*(2*Math.random()-1);

                    let delay = (new Array(i*3)).fill(0);
                    let riseSprite = Website.game.getAnimatedSpriteWithOrder("effects/ecommerce", "down-arrow", delay.concat([0, 1, 2, 3, 4, 5, 6, 7, 0, 1, 2, 3, 4, 0, 4, 0, 4, 0]), 0.3);
                    riseSprite.loop = false;
                    riseSprite.play();
                    riseSprite.anchor.set(0.5, 0.5);
                    riseSprite.position.set(startX, startY);
                    effectsGraphics.item.pixiLayer.addChild(riseSprite);
                    
                }
            }
            
            
        }
        else if(playerId === "ninni"){
            let numberOfStones = 20+Math.round(Math.random()*10)
            for(let i = 0; i < numberOfStones; i++) {
                let partGraphics = new Website.game.gameplay.graphics.PhysicsGraphics();
                let effectSprite = Website.game.getSprite("objects/milk-bottle", "drop");
                effectSprite.anchor.set(0.5, 1);
                partGraphics.item.x = sprite.x+this.item.cameraPosition-Website.game.Sizes.CENTER_X;
                partGraphics.item.y = -1*(sprite.y-Website.game.Sizes.GROUND_POSITION);
                partGraphics.setIntialPosition(this.item.cameraPosition);
                Matter.World.add(this.item.physicsEngine.world, partGraphics.item.physicsBody);

                partGraphics.item.followDirection = true
                let forceScale = 0.005;
                partGraphics.applyForce(forceScale*2*(2*Math.random()-1), Math.random()*2*(Math.random()+2)*forceScale);
                this.addGraphics(partGraphics.item, this.item.gameLayer);
                partGraphics.addSprite(effectSprite);
            }
        }
        else if(playerId === "svenne") {

            {
                let partGraphics = new Website.game.gameplay.graphics.PhysicsGraphics();
                let effectSprite = Website.game.getSprite("objects/ball-bearings", "ring");
                effectSprite.anchor.set(0.5, 0.5);
                partGraphics.item.x = sprite.x+this.item.cameraPosition-Website.game.Sizes.CENTER_X;
                partGraphics.item.y = -1*(sprite.y-Website.game.Sizes.GROUND_POSITION);
                partGraphics.setIntialPosition(this.item.cameraPosition);
                Matter.World.add(this.item.physicsEngine.world, partGraphics.item.physicsBody);

                let forceScale = 0.005;
                
                partGraphics.applyForce(forceScale*2*(2*Math.random()-1), (5+2*Math.random())*forceScale);
                this.addGraphics(partGraphics.item, this.item.gameLayer);
                partGraphics.addSprite(effectSprite);
            }
            let numberOfStones = 6;
            for(let i = 0; i < numberOfStones; i++) {
                let partGraphics = new Website.game.gameplay.graphics.PhysicsGraphics();
                let effectSprite = Website.game.getSprite("objects/ball-bearings", "ball");
                effectSprite.anchor.set(0.5, 0.5);
                partGraphics.item.x = sprite.x+this.item.cameraPosition-Website.game.Sizes.CENTER_X;
                partGraphics.item.y = -1*(sprite.y-Website.game.Sizes.GROUND_POSITION);
                partGraphics.setIntialPosition(this.item.cameraPosition);
                Matter.World.add(this.item.physicsEngine.world, partGraphics.item.physicsBody);

                let forceScale = 0.005;
                partGraphics.applyForce(forceScale*2*(2*Math.random()-1), 2*(Math.random()+2)*forceScale);
                this.addGraphics(partGraphics.item, this.item.gameLayer);
                partGraphics.addSprite(effectSprite);
            }
        }
        else if(playerId === "theo") {

            {
                let numberOfStones = 2+Math.round(Math.random()*4);
                let textures = Website.game.getTextures("objects/notes", "single-note")
                for(let i = 0; i < numberOfStones; i++) {
                    let partGraphics = new Website.game.gameplay.graphics.PhysicsGraphics();
                    let effectSprite = new PIXI.Sprite(textures[Math.floor(textures.length*Math.random())]);
                    effectSprite.anchor.set(0.5, 1);
                    partGraphics.item.x = sprite.x+this.item.cameraPosition-Website.game.Sizes.CENTER_X;
                    partGraphics.item.y = -1*(sprite.y-Website.game.Sizes.GROUND_POSITION);
                    partGraphics.setIntialPosition(this.item.cameraPosition);
                    Matter.World.add(this.item.physicsEngine.world, partGraphics.item.physicsBody);

                    partGraphics.item.physicsBody.torque = 0.02*(2*Math.random()-1);
                    partGraphics.item.noGravity = true;
                    let forceScale = 0.005;
                    partGraphics.applyForce(forceScale*(2*Math.random()-1), 2*(Math.random()+2.5)*forceScale);
                    this.addGraphics(partGraphics.item, this.item.gameLayer);
                    partGraphics.addSprite(effectSprite);
                }
            }

            {
                let numberOfStones = 2+Math.round(Math.random()*4);
                let textures = Website.game.getTextures("objects/notes", "double-note")
                for(let i = 0; i < numberOfStones; i++) {
                    let partGraphics = new Website.game.gameplay.graphics.PhysicsGraphics();
                    let effectSprite = new PIXI.Sprite(textures[Math.floor(textures.length*Math.random())]);
                    effectSprite.anchor.set(0.5, 1);
                    partGraphics.item.x = sprite.x+this.item.cameraPosition-Website.game.Sizes.CENTER_X;
                    partGraphics.item.y = -1*(sprite.y-Website.game.Sizes.GROUND_POSITION);
                    partGraphics.setIntialPosition(this.item.cameraPosition);
                    Matter.World.add(this.item.physicsEngine.world, partGraphics.item.physicsBody);

                    partGraphics.item.physicsBody.torque = 0.02*(2*Math.random()-1);
                    partGraphics.item.noGravity = true;
                    let forceScale = 0.005;
                    partGraphics.applyForce(forceScale*(2*Math.random()-1), 2*(Math.random()+2.5)*forceScale);
                    this.addGraphics(partGraphics.item, this.item.gameLayer);
                    partGraphics.addSprite(effectSprite);
                }
            }
            
        }


        Matter.World.remove(this.item.physicsEngine.world, body);
        this.item.gameLayer.removeChild(sprite);

        this.projectiles.splice(index, 1);

        if(isHit) {

        }
        else {
            let sound = Website.game.getTextures("sounds/game", "miss")[0];
            sound.play({loop: false, volume: 0.5});
        }

        if(playerId === "ninni") {
            let sound = Website.game.getTextures("sounds/game", "milk-splash")[0];
            sound.play({loop: false, volume: 0.5});
        }
    }

    removeProjectileWithoutEffect(body) {
        //console.log("removeProjectileWithoutEffect");
        const index = this.projectiles.findIndex(p => p.body === body);
        if (index === -1) return;

        const { sprite } = this.projectiles[index];

        Matter.World.remove(this.item.physicsEngine.world, body);
        this.item.gameLayer.removeChild(sprite);

        this.projectiles.splice(index, 1);
    }

    addBackground(aItem, aLayer = null) {
        if(!aLayer) {
            aLayer = this.item.backgroundLayer;
        }

        aLayer.addChild(aItem.pixiLayer);
        this.graphics.push(aItem);
    }

    addGroundLayer(aItem) {
        this.item.groundLayer.addChild(aItem.pixiLayer);
        this.graphics.push(aItem);
    }

    addGroundBackLayer(aItem) {
        this.item.parallaxLayer2.addChild(aItem.pixiLayer);
        this.graphics.push(aItem);
    }

    addGraphics(aItem, aLayer) {
        aLayer.addChild(aItem.pixiLayer);
        this.graphics.push(aItem);
    }

    setupBackground() {
        

        let baseSpeed = 0.01;
        let level = 1+((this.item.game.level-1)%8);

        if(level === 1) {
            {
                this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("backgrounds/light-sky", "main", 0, 0.5*baseSpeed, false));
            }
            
            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/forrest", "layer", 0, 1*baseSpeed, true, 35));
            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/forrest", "layer", 1, 3*baseSpeed, true, 25));
            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/forrest", "layer", 2, 6*baseSpeed, true, 5));

            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/grass-field", "layer", 0, 0.1, true, -5), this.item.parallaxLayer4);
        }
        else if(level === 6) {

            {
                this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("backgrounds/light-sky", "main", 0, 0.5*baseSpeed, false));
            }

            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/forrest", "layer", 0, 1*baseSpeed, true, 20));
            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/forrest", "layer", 1, 3*baseSpeed, true, 10));
            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/forrest", "layer", 2, 5*baseSpeed, true, 0));

            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/field", "layer", 0, 0.1, true, -20), this.item.parallaxLayer3);
        }
        else if(level === 5) {

            {
                this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("backgrounds/pink-sky", "main", 0, 0.5*baseSpeed, false));
            }

            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/snowy-mountain", "layer", 0, 1*baseSpeed, false, 30));
            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/snowy-mountain", "layer", 1, 2*baseSpeed, false, 30));
            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/snowy-mountain", "layer", 2, 3*baseSpeed, false, 30));
            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/snowy-mountain", "layer", 3, 4*baseSpeed, false, 30));
            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/snowy-mountain", "layer", 4, 5*baseSpeed, false, 30));

            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/snowy-mountain", "water-layer", 0, 5*baseSpeed, false, 30));
            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/snowy-mountain", "water-layer", 1, 6*baseSpeed, false, 30));
            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/snowy-mountain", "water-layer", 2, 0.1, false, 30));
            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/snowy-mountain", "water-layer", 3, 0.2, false, 30));

            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/snowy-mountain", "layer", 5, 5*baseSpeed, false, 30));

            //this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/field", "layer", 0, 0.1, true, -20), this.item.parallaxLayer3);
        }
        else if(level === 7 || level === 8) {

            {
                this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("backgrounds/sea-sky", "main", 0, 0.5*baseSpeed, false));
            }

            //this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/harbour", "layer", 0, 1*baseSpeed, false, 30));
            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/harbour", "layer", 1, 2*baseSpeed, false, 30));
            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/harbour", "layer", 2, 3*baseSpeed, false, 30));
            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/harbour", "layer", 3, 4*baseSpeed, false, 30));
            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/harbour", "layer", 4, 5*baseSpeed, false, 30));

            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/harbour", "water-layer", 0, 5*baseSpeed, false, 30));
            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/harbour", "water-layer", 1, 6*baseSpeed, false, 30));
            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/harbour", "water-layer", 2, 0.1, false, 30));
            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/harbour", "water-layer", 3, 0.2, false, 30));


            //this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/field", "layer", 0, 0.1, true, -20), this.item.parallaxLayer3);
        }
        else if(level === 2) {

            {
                this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("backgrounds/sunset", "main", 0, 0.5*baseSpeed, false));
            }

            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/city", "layer", 0, 1*baseSpeed, false, 15));
            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/city", "layer", 1, 2*baseSpeed, false, 30));
            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/city", "layer", 2, 4*baseSpeed, false, 50));
            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/city", "layer", 3, 6*baseSpeed, false, 50));
        }
        else if(level === 3 || level === 4) {

            {
                this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("backgrounds/midnight", "main", 0, 0.5*baseSpeed, false));
            }

            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/night", "layer", 0, 1*baseSpeed, false, 0));
            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/night", "layer", 1, 2*baseSpeed, false, 20));
            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/night", "layer", 2, 4*baseSpeed, false, 20));
            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/night", "layer", 3, 6*baseSpeed, false, 10));
        }

        
        if(level === 7 || level === 8) {
            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("ground/harbour", "items", 0, 0.3, true, -50));
            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("ground/harbour", "water", 0, 0.5, true, -40));
            this.addBackground(Website.game.gameplay.graphics.createLayeredTiledGraphic("horizon/harbour", "water-layer", 1, 0.8, false, 50));
            this.addGroundLayer(Website.game.gameplay.graphics.createLayeredTiledGraphic("ground/harbour", "harbour", 0, 1));
        }
        else if(level === 2) {
            this.addGroundBackLayer(Website.game.gameplay.graphics.createLayeredTiledGraphic("ground/street", "ground", 0, 1));
            this.addGroundBackLayer(Website.game.gameplay.graphics.createLayeredTiledGraphic("ground/street", "street", 0, 1, true, -19));
            this.addGroundBackLayer(Website.game.gameplay.graphics.createLayeredTiledGraphic("ground/street", "front", 0, 1, true, -9));

            this.addGroundBackLayer(Website.game.gameplay.graphics.createLayeredTiledGraphic("ground/street", "wall", 0, 1, true, -34));
        }
        else if(level === 3 || level === 4) {
            this.addGroundBackLayer(Website.game.gameplay.graphics.createLayeredTiledGraphic("ground/snow", "back", 0, 0.85));
            this.addGroundBackLayer(Website.game.gameplay.graphics.createLayeredTiledGraphic("ground/snow", "back", 1, 0.9));
            this.addGroundBackLayer(Website.game.gameplay.graphics.createLayeredTiledGraphic("ground/snow", "back", 2, 0.95));
            this.addGroundLayer(Website.game.gameplay.graphics.createLayeredTiledGraphic("ground/snow", "snow", 0, 1));
        }
        else {
            this.addGroundLayer(Website.game.gameplay.graphics.createLayeredTiledGraphic("ground/grass", "dirt", 0, 1));
            this.addGroundLayer(Website.game.gameplay.graphics.createLayeredTiledGraphic("ground/grass", "grass", 0, 1));

            this.addGroundBackLayer(Website.game.gameplay.graphics.createLayeredTiledGraphic("ground/grass", "back", 0, 1));
        }

        
    }

    createMovingGraphics(aTexture, aX, aY, aSpeed = 1) {
        let graphics = new Website.game.gameplay.graphics.MovingGraphic();

        graphics.setup(aTexture, true);

        graphics.item.x = aX;
        graphics.item.y = aY;
        graphics.item.speed = aSpeed;

        if(aSpeed === 1) {
            this.item.parallaxLayer1.addChild(graphics.item.pixiLayer);
        }
        else if(aSpeed >= 0.8) {
            this.item.parallaxLayer3.addChild(graphics.item.pixiLayer);
        }
        else  {
            this.item.parallaxLayer4.addChild(graphics.item.pixiLayer);
        }
        this.graphics.push(graphics.item);

        return graphics
    }

    createMovingGroundGraphics(aTexture, aX, aY, aSpeed = 1, aFront = false) {
        let graphics = new Website.game.gameplay.graphics.MovingGraphic();

        graphics.setup(aTexture, true);

        graphics.item.x = aX;
        graphics.item.y = aY;
        graphics.item.speed = aSpeed;
        graphics.item.zIndexBy = "y";

        if(aFront) {
            this.item.groundFrontLayer.addChild(graphics.item.pixiLayer);
        }
        else {
            this.item.groundBackLayer.addChild(graphics.item.pixiLayer);
        }
        this.graphics.push(graphics.item);

        return graphics;
    }

    setupLevel() {
        //console.log("setupLevel");

        if(Dbm.repository.getItem("site").developmentMode) {
            this.item.game.level = Math.max(this.item.game.level, 3); //MEDEBUG
        }

        this.item.gameMode = (this.item.game.level % 4) === 0 ? "boss" : "normal";

        if(this.item.gameMode === "boss") {
            let bossLevel = Math.round(this.item.game.level/4);
            this.item.bossLifes = bossLevel*3;
            this.item.levelLength = 50*bossLevel*Website.game.Sizes.WIDTH;
        }
        else {
            let gameSegments = (9+(this.item.game.level-1)*2);
            this.item.levelLength = gameSegments*Website.game.Sizes.WIDTH;
        }

        

        let levelCenterX = 0.5*this.item.levelLength;

        this.setupBackground();

        let unclamptDifficultyParameter = Dbm.utils.MathFunctions.parametricValue(this.item.game.level-1, 0, 9);
        let difficultyParameter = Dbm.utils.MathFunctions.clamp(unclamptDifficultyParameter, 0, 1);
        

        this.item.minFlyingEnemyLength = Dbm.utils.MathFunctions.linearInerpolation(difficultyParameter, 1*Website.game.Sizes.WIDTH, 0.25*Website.game.Sizes.WIDTH);
        this.item.maxFlyingEnemyLength = Dbm.utils.MathFunctions.linearInerpolation(difficultyParameter, 2*Website.game.Sizes.WIDTH, 1.25*Website.game.Sizes.WIDTH);

        this.item.chanceOfDouble = 0.8*difficultyParameter;
        this.item.chanceOfTripple = 0.3*Math.pow(difficultyParameter, 2);

        let maxCooldownLength = 0.75*Website.game.Sizes.WIDTH;
        let minCooldownLength = 0.25*Website.game.Sizes.WIDTH;

        this.item.cooldownLength = Dbm.utils.MathFunctions.linearInerpolation(difficultyParameter, maxCooldownLength, minCooldownLength);

        this.item.stepsForHeart = Math.round(Dbm.utils.MathFunctions.linearInerpolation(unclamptDifficultyParameter, 5, 12));

        let level = 1+((this.item.game.level-1)%8);

        if(level === 1) {
            {
                let texture = Website.game.getTextures("fence", "main")[0];
                for(let i = 0; i < 8; i++) {
                    let position = Math.round(Math.random()*this.item.levelLength);
                    this.createMovingGraphics(texture, position, Website.game.Sizes.GROUND_POSITION, 0.8);
                }
            }

            {
                let texture = Website.game.getTextures("dalahorse", "main")[0];
                for(let i = 0; i < 4; i++) {
                    let position = Math.round(Math.random()*this.item.levelLength);
                    this.createMovingGraphics(texture, position, Website.game.Sizes.GROUND_POSITION);
                }
            }
            
            {
                let speed = 0.05;

                let minPosition = -1*Website.game.Sizes.CENTER_X/speed;
                let maxPosition = (Website.game.Sizes.WIDTH-Website.game.Sizes.CENTER_X)/speed+this.item.levelLength;

                let texture = Website.game.getTextures("tree", "main")[0];
                for(let i = 0; i < 26; i++) {
                    let parameter = Math.random();
                    let position = (1-parameter)*minPosition+(parameter)*maxPosition;
                    this.createMovingGraphics(texture, position, Website.game.Sizes.GROUND_POSITION+Math.round(Math.random()*10), 0.2);
                }
            }

            {
                let texture = Website.game.getTextures("fox", "main")[0];
                for(let i = 0; i < 2; i++) {
                    let position = Math.round(Math.random()*this.item.levelLength);
                    this.createMovingGraphics(texture, position, Website.game.Sizes.GROUND_POSITION, 0.8);
                }
            }
            
            {
                let texture = Website.game.getTextures("maypole", "main")[0];
                for(let i = 0; i < 2; i++) {
                    let position = Math.round(Math.random()*this.item.levelLength);
                    this.createMovingGraphics(texture, position, Website.game.Sizes.GROUND_POSITION);
                }
            }

            {
                let texture = Website.game.getTextures("objects/snail", "main")[0];
                for(let i = 0; i < 5; i++) {
                    let position = Math.round(Math.random()*this.item.levelLength);

                    let front = Math.random() < 0.5;
                    let reversed = Math.random() < 0.5;
                    let speedMultipler = reversed ? -0.01 : 0.01;

                    let positionY = 2+Math.round(Math.random()*6);
                    if(front) {
                        positionY += 10;
                    }

                    let graphics = this.createMovingGroundGraphics(texture, position, Website.game.Sizes.GROUND_POSITION+positionY, 1+speedMultipler, front);
                    if(reversed) {
                        graphics.item.sprite.scale.x = -1;
                    }
                }
            }
        }
        else if(level === 6) {
            {
                let textures = Website.game.getTextures("horizon/treeline", "tree");
                let numberOfTrees = 16;
                let speed = 0.05;

                let minPosition = -1*Website.game.Sizes.CENTER_X/speed;
                let maxPosition = (Website.game.Sizes.WIDTH-Website.game.Sizes.CENTER_X)/speed+this.item.levelLength;

                for(let i = 0; i < numberOfTrees; i++) {
                    let parameter = (i/(numberOfTrees-1));

                    let x = (1-parameter)*minPosition+(parameter)*maxPosition;

                    let textureIndex = Math.floor(Math.random()*textures.length);
                    this.createMovingGraphics(textures[textureIndex], x, Website.game.Sizes.GROUND_POSITION+Math.round(Math.random()*10)-20, 0.05);
                }
            }
        }
        else if(level === 5) {
            {
                let speed = 0.05;

                let minPosition = -1*Website.game.Sizes.CENTER_X/speed;
                let maxPosition = (Website.game.Sizes.WIDTH-Website.game.Sizes.CENTER_X)/speed+this.item.levelLength;

                let texture = Website.game.getTextures("tree", "main")[0];
                for(let i = 0; i < 26; i++) {
                    let parameter = Math.random();
                    let position = (1-parameter)*minPosition+(parameter)*maxPosition;
                    this.createMovingGraphics(texture, position, Website.game.Sizes.GROUND_POSITION+Math.round(Math.random()*10), 0.2);
                }
            }
        }
        else if(level === 7) {

            {
                let texture = Website.game.getTextures("objects/boat", "main")[0];
                let graphics = this.createMovingGraphics(texture, this.item.levelLength-Website.game.Sizes.CENTER_X, Website.game.Sizes.GROUND_POSITION, 0.8);
                
            }

            let texture = Website.game.getTextures("objects/seagull", "main")[0];
                for(let i = 0; i < 20; i++) {
                    let position = Math.round(Math.random()*this.item.levelLength);

                    let front = Math.random() < 0.5;
                    let reversed = Math.random() < 0.5;

                    let positionY = 2+Math.round(Math.random()*6);
                    if(front) {
                        positionY += 10;
                    }

                    let graphics = this.createMovingGroundGraphics(texture, position, Website.game.Sizes.GROUND_POSITION+positionY, 1, front);
                    if(reversed) {
                        graphics.item.sprite.scale.x = -1;
                    }
                }
        }
        else if(level === 8) {
            
        }
        else if(level === 2) {
            {
                let speed = 0.2;

                let minPosition = -1*Website.game.Sizes.CENTER_X/speed;
                let maxPosition = (Website.game.Sizes.WIDTH-Website.game.Sizes.CENTER_X)/speed+this.item.levelLength;

                let texture = Website.game.getTextures("objects/oak", "main")[0];
                for(let i = 0; i < 4; i++) {
                    let parameter = Math.random();
                    let position = (1-parameter)*minPosition+(parameter)*maxPosition;
                    this.createMovingGraphics(texture, position, Website.game.Sizes.GROUND_POSITION+Math.round(Math.random()*10), speed);
                }
            }

            {
                let positions = [0.3*this.item.levelLength, 0.6*this.item.levelLength];
                let texture = Website.game.getTextures("objects/fastfood", "main")[0];
                for(let i = 0; i < 2; i++) {
                    let position = positions[i];

                    let graphics = this.createMovingGroundGraphics(texture, position, Website.game.Sizes.GROUND_POSITION+5, 1);
                }
            }
        }
        else if(level === 3) {
            {
                let speed = 0.2;

                let minPosition = -1*Website.game.Sizes.CENTER_X/speed;
                let maxPosition = (Website.game.Sizes.WIDTH-Website.game.Sizes.CENTER_X)/speed+this.item.levelLength;

                let texture = Website.game.getTextures("snowy-tree", "main")[0];
                for(let i = 0; i < 26; i++) {
                    let parameter = Math.random();
                    let position = (1-parameter)*minPosition+(parameter)*maxPosition;
                    this.createMovingGraphics(texture, position, Website.game.Sizes.GROUND_POSITION-5+Math.round(Math.random()*10), speed);
                }
            }

            {
                let texture = Website.game.getTextures("hotel", "main")[0];
                this.createMovingGraphics(texture, 0.5*this.item.levelLength, Website.game.Sizes.GROUND_POSITION, 0.5);
            }
        }
        else {
            {
                let speed = 0.2;

                let minPosition = -1*Website.game.Sizes.CENTER_X/speed;
                let maxPosition = (Website.game.Sizes.WIDTH-Website.game.Sizes.CENTER_X)/speed+this.item.levelLength;

                let texture = Website.game.getTextures("tree", "main")[0];
                for(let i = 0; i < 26; i++) {
                    let parameter = Math.random();
                    let position = (1-parameter)*minPosition+(parameter)*maxPosition;
                    this.createMovingGraphics(texture, position, Website.game.Sizes.GROUND_POSITION+Math.round(Math.random()*10), speed);
                }
            }
        }

        

        this.item.gameLayer.addChild(this.item.player.pixiLayer); //MEDEBUG: //

        
        if(this.item.gameMode === "normal") {
            let goalLineX = this.item.levelLength-Website.game.Sizes.CENTER_X;

            this.createMovingGraphics(Website.game.getTextures("objects/level-up-sign", "main")[0], goalLineX, Website.game.Sizes.GROUND_POSITION, 1);
            
            let steps = Math.floor(goalLineX/Website.game.Sizes.WIDTH)-1;

            for(let i = 0; i < steps; i++) {
                let index = i+1;
                let currentPosition = goalLineX-index*2*Website.game.Sizes.WIDTH;

                let step = Math.floor(index/4);
                let imageIndex = index%4;
                if(step >= 10) {
                    this.createMovingGraphics(Website.game.getTextures("objects/sign", "step-long")[0], currentPosition, Website.game.Sizes.GROUND_POSITION, 1);
                }
                else {
                    this.createMovingGraphics(Website.game.getTextures("objects/sign", "step-" + step)[imageIndex], currentPosition, Website.game.Sizes.GROUND_POSITION, 1);
                }
                
            }
        }
        
    }

    setupCharacter() {
        //console.log("setupCharacter");

        let playerId = this.item.game.playerId;
        this.item.player.controller.setupGraphics(playerId);
    }

    prepare() {
        this.item.touchController.controller.setup();
        Dbm.flow.runWhenMatched(this.item.game.properties.inputMode, "touch", Dbm.commands.callFunction(this._enableTouchInterface.bind(this)));
        Dbm.flow.runWhenMatched(this.item.game.properties.inputMode, "keyboard", Dbm.commands.callFunction(this._disableTouchInterface.bind(this)));

        let scoreDisplay = new Website.game.gameplay.graphics.ScoreDisplay();
        this.item.scoreLayer.addChild(scoreDisplay.item.pixiLayer);
        this.item.setValue("scoreDisplay", scoreDisplay.item);

        let lifeItems = [];

        for(let i = 0; i < 3; i++) {
            let lifeDisplay = new Website.game.gameplay.graphics.LifeDisplay();
            this.item.hudLayer.addChild(lifeDisplay.item.pixiLayer);
            lifeDisplay.item.pixiLayer.position.set(10+i*13, 10);
            lifeItems.push(lifeDisplay.item);
        }

        this.item.setValue("lifeItems", lifeItems);

        this.item.boss.controller.setupGraphics();

        /*
        const render = Matter.Render.create({
  element: document.body,
  engine: this.item.physicsEngine,
  options: {
    width: Website.game.Sizes.WIDTH,
    height: Website.game.Sizes.HEIGHT,
    wireframes: false,
    background: "transparent",
    showVelocity: true,
    showAngleIndicator: true,
    showCollisions: true,
    showAxes: true
  }
});

Matter.Render.lookAt(render, {
  min: { x: 0, y: -1*Website.game.Sizes.GROUND_POSITION },
  max: { x: Website.game.Sizes.WIDTH, y: Website.game.Sizes.HEIGHT-Website.game.Sizes.GROUND_POSITION }
});

Matter.Render.run(render);
*/
        this.item.game.controller.enableGameMode();
    }

    _enableTouchInterface() {
        //console.log("_enableTouchInterface");
        this.item.hudLayer.addChild(this.item.touchController.pixiLayer);
    }
    _disableTouchInterface() {
        //console.log("_disableTouchInterface");
        this.item.hudLayer.removeChild(this.item.touchController.pixiLayer);
    }

    reset() {
        this.item.lives = 3;
        this.item.walkSpeed = Website.game.Sizes.START_WALK_SPEED;
    }

    start() {

        //console.log("Level", this.item.game.level, this.item.walkSpeed);
        this.item.game.controller.startLevel();

        this.item.player.invincible = false;
        if(this.item.gameMode === "normal") {
            this.item.position = 0;
            this.item.player.controller.setPosition(0, 0);
        }
        else {
            this.item.position = 0.2*Website.game.Sizes.WIDTH;
            this.item.player.controller.setPosition(0, 0);
            this.item.player.controller.stand();
            
            this.item.bossState = "intro";

            this.item.gameLayer.addChild(this.item.boss.pixiLayer);
            Matter.World.add(this.item.physicsEngine.world, this.item.boss.physicsBody);

            this.item.boss.properties.position.animateValue(0.75*Website.game.Sizes.WIDTH, 0.7);
            //this.item.boss.properties.position.addAdditionalAnimation(0.75*Website.game.Sizes.WIDTH, 0.9*Website.game.Sizes.WIDTH, 0.5, 1);
            this.item.properties.bossState.delayValue("stop", 0.7);
            this.item.properties.bossState.addDelayValue("dialog1", 0.9);
            this.item.properties.bossState.addDelayValue("dialog2", 4);
            this.item.properties.bossState.addDelayValue("dialog3", 7);
            this.item.properties.bossState.addDelayValue("action", 10);
        }
        this.item.cameraPosition = 0.5*Website.game.Sizes.WIDTH;

        this.item.nextFlyingEmemySpawnPosition = 2*Website.game.Sizes.WIDTH;

        //this.item.levelLength = (9+(this.item.game.level-1)*2)*Website.game.Sizes.WIDTH;

        this.item.scoreDisplay.score = this.item.game.score;

        this.item.fadeLayer.envelope = 0;
        this.item.fadeLayer.controller.update(0, 0);

        
        this.item.keyboardController.active = true;
        
        this.item.coinCooldownLength = 0.25*Website.game.Sizes.WIDTH;

        if(this.item.gameMode === "normal") {
            this.item.nextCoinSpawnPosition = 0.9*Website.game.Sizes.WIDTH;
            this.item.nextEmemySpawnPosition = 0.75*Website.game.Sizes.WIDTH;
            this.spawnEnemyWave();
            this.spawnCoin();
        }
        else {
            this.item.nextCoinSpawnPosition = 2.2*Website.game.Sizes.WIDTH;
            this.item.nextEmemySpawnPosition = 2*Website.game.Sizes.WIDTH;
        }

        

        

        {
            let currentArray = this.item.lifeItems;
            let currentArrayLength = currentArray.length;
            for(let i = 0; i < currentArrayLength; i++) {
                if(this.item.lives > i) {
                    let currentItem = currentArray[i];
                    currentItem.controller.startAnimation(i*0.1+0.1);
                }
                
            }
        }

        if(!Dbm.repository.getItem("site").developmentMode) {
            let sound = Website.game.getTextures("sounds/music", "background")[0];
            sound.play( {
                loop: true,
                volume: 0.5
            });
        }
    }

    _bossStateChanged() {
        //console.log(this.item.bossState);
        if(this.item.bossState === "action") {
            this.item.boss.controller.startFight();
            this.item.player.controller.startWalk();
            this.item.boss.speechBubble.controller.hide();
        }
        else if(this.item.bossState === "stop") {
            this.item.boss.wheelsGraphics.controller.showGraphics("stand");
        }
        else if(this.item.bossState === "dialog1") {
            this.item.boss.speechBubble.controller.setText("Stopp och belägg - här blir det avslag och långbänk! Ingen besegrar byråkratin!");
            this.item.boss.speechBubble.controller.show();
        }
        else if(this.item.bossState === "dialog2") {
            this.item.player.speechBubble.controller.setText("Inget stoppar Sveriges entreprenörer och innovatörer - vi kommer fortsätta skapa tillväxt.");
            this.item.player.speechBubble.controller.show();

            this.item.boss.speechBubble.controller.hide();
        }
        else if(this.item.bossState === "dialog3") {
            this.item.boss.speechBubble.controller.setText("Nej - här tar det stopp, fast i pappersarbete och krångliga regelverk!");
            this.item.boss.speechBubble.controller.show();

            this.item.player.speechBubble.controller.hide();
        }
    }

    loseLife() {
        if(this.item.lives > 0) {
            this.item.lives = this.item.lives-1;
            this.item.lifeItems[this.item.lives].controller.makeInactive();
            
            if(this.item.lives <= 0) {
                this.die();
            }
            else {
                this.item.player.invincible = true;
                this.item.player.properties.invincible.delayValue(false, 1.3);

                let sound = Website.game.getTextures("sounds/game", "lose-life")[0];
                sound.play({loop: false, volume: 0.5});
            }
        }
        
    }

    gainLife() {
        this.item.lives = Math.min(3, this.item.lives+1);
        this.item.lifeItems[this.item.lives-1].controller.makeActive();

        if(this.item.lives === 3) {
            this.item.stepsSinceLastHeart = 0;
        }

        let sound = Website.game.getTextures("sounds/game", "heal")[0];
        sound.play({loop: false, volume: 0.5});
    }

    createCoin(x, y) {

        if(this.item.lives < 3) {
            this.item.stepsSinceLastHeart += 1;
        }

        if(this.item.lives < 3 && this.item.stepsSinceLastHeart >= this.item.stepsForHeart) {
            let sprite = new PIXI.Sprite(Website.game.getTextures("objects/heart", "main")[0]);
            sprite.anchor.set(0.5, 0.5);

            let coin = new Website.game.gameplay.gameobjects.Heart();
            coin.item.x = x;
            coin.item.y = y;
            coin.item.animationOffset = Math.random();
            coin.setSprite(sprite);
            coin.setIntialPosition(this.item.cameraPosition);
            Matter.World.add(this.item.physicsEngine.world, coin.item.physicsBody);
            this.item.gameLayer.addChild(coin.item.pixiLayer);

            this.coins.push(coin.item);

            this.item.stepsSinceLastHeart = 0;
        }
        else {
            
            let sprite = Website.game.getAnimatedSpriteWithOrder("objects/coin", "coin", [0,0,0,0,0,0,1,2,3], 0.15);
            sprite.play();
            sprite.anchor.set(0.5, 0.5);

            let coin = new Website.game.gameplay.gameobjects.Coin();
            coin.item.x = x;
            coin.item.y = y;
            coin.item.animationOffset = Math.random();
            coin.setSprite(sprite);
            coin.setIntialPosition(this.item.cameraPosition);
            Matter.World.add(this.item.physicsEngine.world, coin.item.physicsBody);
            this.item.gameLayer.addChild(coin.item.pixiLayer);

            for(let i = 0; i < 3; i++) {

                let x = 6*2*(Math.random()-0.5);
                let y = 6*2*(Math.random()-0.5);

                let order = [0, 1, 2, 3, 4, 4, 4, 4, 3, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

                let blinkSprite = Website.game.getAnimatedSpriteWithOrder("effects/blink/white", "blink", order, 0.5);
                blinkSprite.anchor.set(0.5, 0.5);
                blinkSprite.position.set(x, y);
                blinkSprite.gotoAndPlay(Math.floor(Math.random()*order.length));
                coin.item.pixiLayer.addChild(blinkSprite);
            }
            

            this.coins.push(coin.item);
        }

        
    }

    removeCoin(aPhysicsBody) {
        let index = Dbm.utils.ArrayFunctions.getItemIndexByIfExists(this.coins, "physicsBody", aPhysicsBody);
        if (index === -1) return;
        let coin = this.coins[index];

        Matter.World.remove(this.item.physicsEngine.world, aPhysicsBody);
        this.item.gameLayer.removeChild(coin.pixiLayer);

        this.coins.splice(index, 1);
    }

    addScore(aScore) {
        let currentScore = this.item.game.score;
        let highScore = this.item.game.highScore;
        let newScore = currentScore + aScore;

        this.item.game.score = newScore;
        this.item.scoreDisplay.controller.updateScore(newScore);

        if(currentScore < highScore && newScore >= highScore) {
            this.item.scoreDisplay.controller.showHighscore();
        }
    }

    collectCoin(aPhysicsBody) {

        let index = Dbm.utils.ArrayFunctions.getItemIndexByIfExists(this.coins, "physicsBody", aPhysicsBody);
        if (index === -1) return;
        let coin = this.coins[index];

        let effectsGraphics = new Website.game.gameplay.graphics.MovingGraphic();

        effectsGraphics.item.x = coin.x;
        effectsGraphics.item.y = coin.y+(Website.game.Sizes.GROUND_POSITION+Website.game.Sizes.PLAYER_POSITION);
        effectsGraphics.item.speed = 1;

        this.item.gameLayer.addChild(effectsGraphics.item.pixiLayer);

        this.graphics.push(effectsGraphics.item);

        for(let i = 0; i < 7; i++) {

            let x = 10*2*(Math.random()-0.5);
            let y = 10*2*(Math.random()-0.5);

            let delay = i*1;

            let order = [0, 1, 2, 3, 4, 4, 4, 4, 3, 2, 0];
            let delayedOrder = (new Array(delay)).fill(0, 0, delay).concat(order);

            let blinkSprite = Website.game.getAnimatedSpriteWithOrder("effects/blink/yellow", "blink", delayedOrder, 0.5);
            blinkSprite.anchor.set(0.5, 0.5);
            blinkSprite.position.set(x, y);
            blinkSprite.loop = false;
            blinkSprite.play();
            effectsGraphics.item.pixiLayer.addChild(blinkSprite);
        }


        this.removeCoin(aPhysicsBody);

        this.addScore(this.item.walkSpeed);

        let sound = Website.game.getTextures("sounds/game", "collect-coin")[0];
        sound.play({loop: false, volume: 0.5});
    }

    collectHeart(body) {
        //this.removeCoin(body);

        let sound = Website.game.getTextures("sounds/game", "heal")[0];
        sound.play({loop: false, volume: 0.5});
    }

    spawnCoin() {
        //console.log("spawnCoin");
        //return; //MEDEBUG

        if(this.item.nextCoinSpawnPosition < (this.item.levelLength-Website.game.Sizes.CENTER_X)) {
            let parameter = Math.random();
            let yPosition = -1*parameter*(this.groundPosition-25)-25;
            this.createCoin(this.item.nextCoinSpawnPosition, yPosition);
        }

        this.item.nextCoinSpawnPosition += this.item.coinCooldownLength;
    }

    spawnEnemyWave() {
        //console.log("spawnEnemyWave");
        //return; //MEDEBUG

        let lastPosition = this.item.levelLength-0.5*Website.game.Sizes.WIDTH-30;

        let numberOfCloseItems = 0;
        let modeParameter = Math.random();

        //console.log(modeParameter, this.item.chanceOfTripple, this.item.chanceOfDouble);

        if(modeParameter < this.item.chanceOfTripple) {
            numberOfCloseItems = 2;
        }
        else if(modeParameter < this.item.chanceOfDouble) {
            numberOfCloseItems = 1;
        }

        let minDistance = 90;
        let maxRandomDistance = Math.min(140, this.item.cooldownLength)-minDistance;

        let currentPosition = this.item.nextEmemySpawnPosition;

        for(let i = 0; i < numberOfCloseItems; i++) {
            if(currentPosition < lastPosition) {
                this.createEnemy(currentPosition);
                currentPosition = Math.round(currentPosition+10+Math.random()*50);
            }
        }

        let numberOfEnemies = Math.floor(Math.random()*3)+1;
        for(let i = 0; i < numberOfEnemies; i++) {
            if(currentPosition < lastPosition) {
                this.createEnemy(currentPosition);
                if(i+1 < numberOfEnemies) {
                    currentPosition = Math.round(currentPosition+minDistance+Math.random()*maxRandomDistance);
                }
            }
        }

        this.item.nextEmemySpawnPosition = currentPosition+this.item.cooldownLength;
    }

    spawnFlyingEnemy() {
        
        let lastPosition = this.item.levelLength-0.5*Website.game.Sizes.WIDTH;
        let currentPosition = this.item.nextFlyingEmemySpawnPosition;

        if(currentPosition < lastPosition) {
            let yPositions = [Website.game.Sizes.CHARACTER_HEIGHT+20, Website.game.Sizes.CHARACTER_HEIGHT+50, Website.game.Sizes.CHARACTER_HEIGHT+80];

            let yPositionIndex = Math.floor(yPositions.length*Math.random());
            this.createFlyingEnemy(currentPosition, yPositions[yPositionIndex]);
        }

        let parameter = Math.random();

        let length = Math.round((1-parameter)*this.item.minFlyingEnemyLength+(parameter)*this.item.maxFlyingEnemyLength);

        this.item.nextFlyingEmemySpawnPosition += length;
    }

    die() {
        if(this.item.game.score > this.item.game.highScore) {
            this.item.game.highScore = this.item.game.score;
        }

        let sound = Website.game.getTextures("sounds/game", "gameover")[0];
        sound.play({loop: false, volume: 0.5});

        this.item.game.controller.endLevel(false);
        this.item.game.controller.changeScreen("preGameOver");
    }

    completedLevel() {
        this.item.game.controller.endLevel(true);
        this.item.game.controller.changeScreen("levelCompleted");

        let sound = Website.game.getTextures("sounds/interface", "level-completed")[0];
        sound.play({loop: false, volume: 0.3});
    }

    update() {

        let time = this.item.game.timer.time;
        let deltaTime = this.item.game.timer.delta;

        let walkLength = 0;

        if(this.item.gameMode === "boss" && this.item.bossState !== "action") {
            
        }
        else {
            walkLength = (this.item.walkSpeed*deltaTime);
            this.item.position += walkLength;
        }
        

        

        let standardPlayerPosition = 0.2*Website.game.Sizes.WIDTH;
        let standardCameraDistance = (0.5*Website.game.Sizes.WIDTH-standardPlayerPosition);
        let cameraPosition = this.item.cameraPosition;
        let currentPlayerDistance = cameraPosition-this.item.position;
        if(cameraPosition-this.item.position < standardCameraDistance) {
            cameraPosition = this.item.position+standardCameraDistance;
        }
        else {
            let maxDistance = Website.game.Sizes.CENTER_X;
            let parameter = Math.max(0, Math.min(1, 1-((currentPlayerDistance-standardCameraDistance)/(maxDistance-standardCameraDistance))));
            cameraPosition += walkLength*Math.pow(parameter, 2);
        }

        cameraPosition = Math.min(cameraPosition, this.item.levelLength-Website.game.Sizes.CENTER_X);

        this.item.cameraPosition = cameraPosition;

        let localPlayerPosition = 0.5*Website.game.Sizes.WIDTH-(cameraPosition-this.item.position);

        

        let stepLength = 1/240;
        let steps = Math.round(deltaTime/stepLength);

        for(let i = 0; i < steps; i++) {
            this.item.player.controller.updateControl(time, stepLength);
            Matter.Engine.update(this.item.physicsEngine, 1000*stepLength);
        }

        this.item.player.controller.setScreenX(localPlayerPosition);
        
        
        this.item.player.controller.updatePositionFromPhysics();
        this.item.player.controller.update(time, deltaTime);
        this.item.scoreDisplay.controller.update(time, deltaTime);

        let fadeLength = 0.5*Website.game.Sizes.WIDTH;
        let fadeEnvelope = Math.max(0, Math.min(1, (this.item.position-(this.item.levelLength-fadeLength))/fadeLength));
        this.item.fadeLayer.x = localPlayerPosition+0.5*Website.game.Sizes.CHARACTER_WIDTH;
        this.item.fadeLayer.y = Website.game.Sizes.GROUND_POSITION-Website.game.Sizes.PLAYER_POSITION-0.5*Website.game.Sizes.CHARACTER_HEIGHT;
        this.item.fadeLayer.envelope = fadeEnvelope;
        this.item.fadeLayer.controller.update(time, deltaTime);

        if(this.item.position > this.item.levelLength) {
            this.completedLevel();
        }

        if(this.item.gameMode === "boss") {
            this.item.boss.controller.update(time, deltaTime);
        }
        else {
            if(cameraPosition+Website.game.Sizes.CENTER_X >= this.item.nextFlyingEmemySpawnPosition) {
                this.spawnFlyingEnemy();
            }
        }
        
        if(cameraPosition+Website.game.Sizes.CENTER_X >= this.item.nextCoinSpawnPosition) {
            this.spawnCoin();
        }

        if(cameraPosition+Website.game.Sizes.CENTER_X >= this.item.nextEmemySpawnPosition) {
            this.spawnEnemyWave();
        }

        {
            let currentArray = this.item.lifeItems;
            let currentArrayLength = currentArray.length;
            for(let i = 0; i < currentArrayLength; i++) {
                let currentItem = currentArray[i];
                currentItem.controller.update(time, deltaTime);
            }
        }

        {
            let currentArray = this.graphics;
            let currentArrayLength = currentArray.length;
            for(let i = 0; i < currentArrayLength; i++) {
                let currentItem = currentArray[i];
                currentItem.controller.update(cameraPosition, time, deltaTime);
            }
        }

        let PROJECTILE_RADIUS = 5;
        let projecttileRotationSpeed = 2;

        for (const p of this.projectiles) {
            p.sprite.x = Math.round(p.body.position.x);
            
            p.sprite.y = Math.round(p.body.position.y)+PROJECTILE_RADIUS+(this.groundPosition+this.playerPosition);
            p.sprite.rotation = 2*Math.PI*time*projecttileRotationSpeed;
        }

        {
            let currentArray = this.coins;
            let currentArrayLength = currentArray.length;
            for(let i = 0; i < currentArrayLength; i++) {
                let currentItem = currentArray[i];
                currentItem.controller.update(cameraPosition, time, deltaTime);
            }
        }

        
        {
            let currentArray = this.enemies;
            let currentArrayLength = currentArray.length;
            for(let i = 0; i < currentArrayLength; i++) {
                let currentItem = currentArray[i];
                currentItem.controller.update(cameraPosition, time, deltaTime);
            }
        }

        {
            let currentArray = this.graphics;
            let currentArrayLength = currentArray.length;
            for(let i = 0; i < currentArrayLength; i++) {
                let currentItem = currentArray[i];
                if(currentItem.controller.hasPassed(cameraPosition)) {
                    currentItem.pixiLayer.parent.removeChild(currentItem.pixiLayer);

                    if(currentItem.physicsBody) {
                        Matter.World.remove(this.item.physicsEngine.world, currentItem.physicsBody);
                    }

                    currentArray.splice(i, 1);
                    i--;
                    currentArrayLength--;
                }
            }
        }
    }

    stop() {
        this.item.keyboardController.active = false;

        {
            let currentArray = [].concat(this.coins);
            let currentArrayLength = currentArray.length;
            for(let i = 0; i < currentArrayLength; i++) {
                let currentItem = currentArray[i];
                this.removeCoin(currentItem.physicsBody);
            }
        }
        
        {
            let currentArray = [].concat(this.enemies);
            let currentArrayLength = currentArray.length;
            for(let i = 0; i < currentArrayLength; i++) {
                let currentItem = currentArray[i];
                this.removeEnemy(currentItem.physicsBody);
            }
        }

        {
            let currentArray = [].concat(this.projectiles);
            let currentArrayLength = currentArray.length;
            for(let i = 0; i < currentArrayLength; i++) {
                let currentItem = currentArray[i];
                this.removeProjectileWithoutEffect(currentItem.body);
            }
        }

        this.removeAllGraphics();

        if(this.item.gameMode === "normal") {
            
        }
        else {
            this.item.boss.controller.stopFight();
            this.item.gameLayer.removeChild(this.item.boss.pixiLayer);
            Matter.World.remove(this.item.physicsEngine.world, this.item.boss.physicsBody);
        }

        let sound = Website.game.getTextures("sounds/music", "background")[0];
        sound.stop();
    }

    removeAllGraphics() {
        let currentArray = this.graphics;
        let currentArrayLength = currentArray.length;
        for(let i = 0; i < currentArrayLength; i++) {
            let currentItem = currentArray[i];
            currentItem.pixiLayer.parent.removeChild(currentItem.pixiLayer);

            if(currentItem.physicsBody) {
                Matter.World.remove(this.item.physicsEngine.world, currentItem.physicsBody);
            }
        }

        this.graphics = [];
    }
}